import Reveal from '@/components/feature/Reveal';
import SectionHeader from './SectionHeader';

const blocks = [
  {
    icon: 'ri-stack-line',
    title: 'Producto',
    desc: 'Entendemos que una aplicación debe resolver un problema y generar valor, no simplemente funcionar.',
  },
  {
    icon: 'ri-git-branch-line',
    title: 'Arquitectura',
    desc: 'Diseñamos pensando en crecimiento, mantenimiento e integración.',
  },
  {
    icon: 'ri-brain-line',
    title: 'IA aplicada',
    desc: 'Integramos inteligencia artificial donde realmente aporta valor.',
  },
  {
    icon: 'ri-building-4-line',
    title: 'Experiencia empresarial',
    desc: 'Entendemos sistemas ERP, procesos empresariales e integraciones complejas.',
  },
  {
    icon: 'ri-route-line',
    title: 'End-to-End',
    desc: 'Podemos participar desde la idea inicial hasta producción.',
  },
];

export default function WhyAcoma() {
  return (
    <section className="relative py-20 md:py-28 bg-background-900/40 border-y border-background-800/60">
      <div className="mx-auto max-w-7xl px-4 md:px-6">
        <SectionHeader
          eyebrow="Por qué ACOMA"
          title="Pensamos más allá del código."
        />

        <div className="mt-14 grid grid-cols-1 sm:grid-cols-2 lg:grid-cols-5 gap-5">
          {blocks.map((b, i) => (
            <Reveal key={b.title} delay={i * 70}>
              <div className="h-full rounded-lg border border-background-700/60 bg-background-950/60 p-6 text-center transition-all duration-300 hover:-translate-y-1 hover:border-secondary-500/40">
                <div className="w-11 h-11 mx-auto flex items-center justify-center rounded-lg bg-background-800 border border-background-700/60 text-secondary-400">
                  <i className={`${b.icon} text-xl`}></i>
                </div>
                <h3 className="mt-4 text-base font-bold font-heading text-foreground-950">
                  {b.title}
                </h3>
                <p className="mt-2 text-sm text-foreground-500 leading-relaxed">
                  {b.desc}
                </p>
              </div>
            </Reveal>
          ))}
        </div>
      </div>
    </section>
  );
}